export type LayoutState = 'loading' | 'error' | 'content';

type ResolveLayoutStateParams = {
    isLoading: boolean;
    hasSectionDetails: boolean;
    hasSectionLoadError: boolean;
};

export const resolveLayoutState = ({
    isLoading,
    hasSectionDetails,
    hasSectionLoadError,
}: ResolveLayoutStateParams): LayoutState => {
    if (isLoading) {
        return 'loading';
    }

    if (hasSectionDetails) {
        return 'content';
    }

    if (hasSectionLoadError) {
        return 'error';
    }

    return 'loading';
};
